import React, { useMemo } from 'react';
import { components } from 'common';
const { If } = components;
import { IUserBaseInfo } from '@umu/umu-types';

import UserName from '../../user/userName/userName';
import UserAvatar from '../../user/userAvatar/userAvatar';
import { TUserLevelSize } from '../../user/userLevelBadge/userLevelBadge';
import './triangleUserInfo.scss';

interface ITriangleUserInfo {
    userInfo: IUserBaseInfo;
    hideLevel?: boolean;
    avatarWidth?: number;
    children?: JSX.Element | string;
    userLevelSize?: TUserLevelSize;
    disableJump?: boolean;
}

export const TriangleUserInfo = (props: ITriangleUserInfo) => {
    const { children, disableJump, userInfo, hideLevel, avatarWidth = 36, userLevelSize } = props;
    const content = useMemo(() => {
        return (
            <>
                <UserAvatar
                    src={userInfo.avatar}
                    className="triangl-info-left"
                    width={avatarWidth}
                    userLevelInfo={userInfo.user_level}
                    userLevelSize={userLevelSize}
                    showUserLevel={hideLevel ? 0 : userInfo.show_user_level}
                />
                <div className="triangl-info-right">
                    <UserName
                        userMedalWidth={20}
                        name={userInfo.user_name}
                        className="triangl-info-name"
                        userMedalInfo={userInfo.user_medal}
                        showUserLevel={userInfo.show_user_level}
                    />
                    <If condition={!!children}>
                        <div className="triangl-info-other">{children}</div>
                    </If>
                </div>
            </>
        );
    }, [userInfo]);

    const render = () => {
        if (disableJump || !userInfo.home_url) {
            return <div className="triangl-info-content">{content}</div>;
        } else {
            return (
                <a href={userInfo.home_url} target="_blank" className="triangl-info-content">
                    {content}
                </a>
            );
        }
    };

    return render();
};
